import React from 'react';
import moment from "moment/moment";
import "./styles.scss";
import {
  DateRangeOutlined,
  AccessTimeOutlined,
} from "@mui/icons-material";

interface DateAndTimeProps{
  date:string
  time:string
}
const DateAndTime:React.FC<DateAndTimeProps> = ({date,time}) => {
  return (
          <div className='lesson_date_area'>
            <span><DateRangeOutlined/>{moment(date).format('YYYY-MM-DD')}</span>
            <span><AccessTimeOutlined/>{moment(time).format('hh:mm A')}</span>
          </div>
  )
}

export default DateAndTime;